import React, { useEffect, useState } from "react";
import { useNavigate, UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SideBar from "../SideBar/SideBar";
import "./Newticket.css";
import {
  FormControlLabel,
  LinearProgress,
  Radio,
} from "@mui/material";
import axiosApiInstance from "../axios";
import AllTicketsHeader from '../AllTickets/AllTicketsHeader';
import TextField from '@mui/material/TextField';
import _ from 'lodash';
import usePrompt from "./usePrompt";
 
const Newticket = () => {
  const Input = styled("input")({
    display: "none",
  });

  const [title, setTitle] = useState("");
  const [ticketDescription, setticketDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [categoryId, setCategoryId] = useState(0);
  const [subCategoryId, setSubCategoryId] = useState(0);
  const [assignValues, setAssignValues] = useState([]);
  const [assignOptions, setAssignOptions] = useState([]);

  useEffect(() => {
    axiosApiInstance
      .get(`/category`)
      .then((resp) => setCategories(resp.data.data));
  }, []);

  const getSubCategoryList = (id) => {
    axiosApiInstance
      .get(`/subCategory/${id}`)
      .then((resp) => setSubCategories(resp.data.data));
  };

  const [clients, setClients] = useState([]);
  const [clientId, setClientId] = useState(0);

  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState(0);

  const [priorityId, setPriorityId] = useState(3);

  const [status, setStatus] = useState([]);
  const [statusId, setStatusId] = useState(21);

  useEffect(() => {
    axiosApiInstance.get(`/status`).then((req) => setStatus(req.data.data));
  }, []);

  const [dueDate, setDueDate] = useState(new Date());
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    axiosApiInstance.get(`/faq`).then((req) => setQuestions(req.data.data));
  }, []);

  const [files, setFiles] = useState([]);
  const [showName, setShowName] = useState([]);
  const [errorDate, setErrorDate] = useState([]);
  const [errorTitle, setErrorTitle] = useState(null);
  const [errorDesc, setErrorDesc] = useState(null);
  const [errorCat, setErrorCat] = useState(null);
  const [errorClient, setErrorClient] = useState(null);
  const [errorProject, setErrorProject] = useState(null);
  const [errorAssign, setErrorAssign] = useState(null);
  const [errfileformat, setErrfileformat] = useState(null);
  const [errfileSize, setErrfileSize] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDirty, setIsDirty] = useState(false);
  const { handleCustomBackButton } = usePrompt("You have unsaved changes. Are you sure you want to leave?", isDirty);
  const onFileChange = (e) => {
    const allAttach = Array.from(e.target.files).map((file) => file);

    const fileArray = Array.from(e.target.files).map((file) => file.name);
    const fileSize = Array.from(e.target.files).map((file) => file.size);
    const fileExtension = fileArray.toString().split(".").at(-1);
    // console.log("fileExtension", fileExtension);
    const allowedFileTypes = [
      "jpg",
      "png",
      "zip",
      "txt",
      "doc",
      "docx",
      "jpeg",
      "xlsx",
      "xls",
      "pdf",
    ];
    if (!allowedFileTypes?.includes(fileExtension)) {
      setErrfileformat(
        `*File type does not support`
      );
      return false;
    } else {
      setErrfileformat(null);
    }
    if (fileSize > 5163523) {
      setErrfileSize("*Please upload a file smaller than 5 MB");
      return false;
    } else {
      setErrfileSize(null);
    }
    setFiles((prevAtt) => prevAtt.concat(allAttach));
    setShowName((prevNames) => prevNames.concat(fileArray));
  };

  const remFile = (e) => {
    let x = e.target.getAttribute("delattach");
    setFiles(files.filter((v) => v.name !== x));
    setShowName(showName.filter((art) => art !== x));
  };

  const inputTitle = (e) => {
    setIsDirty(true);
    let value = e?.target.value;
    setTitle(value);
    if (!value.trim()) {
      setErrorTitle("*Title field is required");
      setLoading(false);
      setIsDisable(false);
    } else {
      if(value.length === 250){
        setErrorTitle("Only 250 characters allowed");
      }else{
        setErrorTitle(null);
      }
    }
  };

  const inputDesc = (e) => {
    setIsDirty(true);
    setticketDescription(e.target.value);
    if (!e.target.value.trim()) {
      setErrorDesc("*Description field is required");
    } else {
      setErrorDesc(null);
    }
  };

  const inputEvent = (event) => {
    setIsDirty(true);
    getSubCategoryList(event.target.value);
    setSubCategoryId(0);
    setCategoryId(event.target.value);
    if (!event.target.value) {
      setErrorCat("*Category field is required");
    } else {
      setErrorCat(null);
    }
  };

  const onChangeClient = (e, value) => {
    setIsDirty(true);
    setClientId(value?.id ? value.id : 0);
    if (value?.id === 0) {
      setErrorClient("*Client field is required");
    } else {
      setErrorClient('');
    }
  }

  const inputEventSubCategory = (event) => {
    setIsDirty(true);
    setSubCategoryId(event.target.value);
  };

  const onChangeProject = (e, value) => {
    setIsDirty(true);
    setProjectId(value?.id ? value.id : 0);
    if (value?.id === 0) {
      setErrorProject("*Project tag field is required");
    } else {
      setErrorProject('');
    }
  }

  const inputEvent4 = (event) => {
    setIsDirty(true);
    setStatusId(event.target.value);
  };

  const cancelButton = (e) => {
    setIsDirty(false);
    e.preventDefault();
    navigate(-1);
  };

  const [isDisable, setIsDisable] = useState(false);

  const navigate = useNavigate();
  const formSubmit = (e) => {
    setIsDirty(false);
    const assignIds = Array.isArray(assignValues) ? assignValues.map((x) => x.id) : [];
    e.preventDefault();
    setIsDisable(true);
    setLoading(true);

    let bodyFormData = new FormData();
    if(subCategoryId!==0){
      bodyFormData.append("SubCategoryId", subCategoryId);
    }
    bodyFormData.append("title", title);
    bodyFormData.append("ticketDescription", ticketDescription);
    bodyFormData.append("categoryId", categoryId);
   
    bodyFormData.append("clientId", clientId);
    bodyFormData.append("projectId", projectId);
    bodyFormData.append("priorityId", priorityId);
    bodyFormData.append("statusId", statusId);
    for (let i = 0; i < assignIds.length; i++) {
      let finalList = assignIds[i];
      bodyFormData.append("listassignid", finalList);
    }
    for (let j = 0; j < files.length; j++) {
      let finalFiles = files[j];
      bodyFormData.append("formFiles", finalFiles);
    }
    bodyFormData.append("dueDate", dueDate && dueDate.toISOString());
    for (var pair of bodyFormData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    if(!dueDate){
      setLoading(false);
      setIsDisable(false);
      setErrorDate("*Date field is required");
    }
    if (!title.trim()) {
      setLoading(false);
      setIsDisable(false);
      setErrorTitle("*Title field is required");
    }
    if (!ticketDescription.trim()) {
      setErrorDesc("*Description field is required");
      setLoading(false);
      setIsDisable(false);
    }
    if (categoryId === 0) {
      setErrorCat("*Category field is required");
      setLoading(false);
      setIsDisable(false);
    }
    if (clientId === 0) {
      setErrorClient("*Client field is required");
      setLoading(false);
      setIsDisable(false);
    }
    
    if (projectId === 0) {
      setErrorProject("*Project Tag field is required");
      setLoading(false);
      setIsDisable(false);
    }

    if (assignIds.length < 1) {
      setErrorAssign("*Assign To field is required");
      setLoading(false);
      setIsDisable(false);
    }
     if (title.trim() && ticketDescription.trim() && categoryId !== 0 && clientId !== 0 && projectId !== 0 &&assignIds.length > 0 && dueDate) {
       axiosApiInstance.post("/ticket", bodyFormData).then((res) => {
        if (res.data.succeeded === true) {
          setLoading(false);
          setIsDisable(false);
          navigate("/");
        } else {
          setErrorTitle(res.data.message)
          setLoading(false);
          setIsDisable(false);
        }
      });
    }
  
  };

  const searchHandler = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  const onInputChange = _.debounce((e, value) => {
    if (value !== '') {
      axiosApiInstance
        .get(`/user/${value}`)
        .then((response) => {
          if (response.data.succeeded) {
            setAssignOptions(response.data.data);
          }
        })
        .catch((err) => console.log(err));
    } else {
      setAssignOptions([]);
    }
  }, 500);

  // Fetch clients for initial load or reset
  const fetchDefaultClients = async () => {
    try {
        setLoading(true);
        const response = await axiosApiInstance.get('/client'); // Replace with your default client API
        if (response.data.succeeded) {
            setClients(response.data.data);
        }
    } catch (error) {
        console.error('Error fetching default clients:', error);
    } finally {
        setLoading(false);
    }
};

// Initial fetch of default clients
useEffect(() => {
    fetchDefaultClients();
}, []);


  const onInputChangeClient = _.debounce((e, value) => {
    if (value !== '') {
      axiosApiInstance
        .get(`/client/GetClientBasedOnSearch?data=${value}`)
        .then((response) => {
          if (response.data.succeeded) {
            setClients(response.data.data);
          }
        })
        .catch((err) => console.log(err));
    } else {
      fetchDefaultClients();
    }
  }, 500);

     // Fetch projects for initial load or reset
     const fetchDefaultProjects = async () => {
      try {
          setLoading(true);
          const response = await axiosApiInstance.get('/project'); // Replace with your default project API
          if (response.data.succeeded) {
              setProjects(response.data.data);
          }
      } catch (error) {
          console.error('Error fetching default projects:', error);
      } finally {
          setLoading(false);
      }
  };

  // Initial fetch of default projects
  useEffect(() => {
      fetchDefaultProjects();
  }, []);

  const onInputChangeProject = _.debounce((e, value) => {
    if (value !== '') {
      axiosApiInstance
        .get(`/project/GetProjectBasedOnSearch?data=${value}`)
        .then((response) => {
          if (response.data.succeeded) {
            setProjects(response.data.data);
          }
        })
        .catch((err) => console.log(err));
    } else {
         // If input is cleared, reload default projects
            fetchDefaultProjects();
    }
  }, 500);

  const onChangeAssignValues = (e, values, reason, detail) => {
    const seen = new Set();
    const filteredArr = values.filter(el => {
      const duplicate = seen.has(el.id);
      seen.add(el.id);
      return !duplicate;
    });
    setAssignValues(filteredArr);
    if (values.length > 0) {
      setErrorAssign('');
    }
  }

  const handleChangeDate = (date) =>{
    setDueDate(date);
    setErrorDate('');
  }
  
  return (
    <>
      <AllTicketsHeader searchKeyword={searchHandler} term={searchTerm} />
      <SideBar />
      <div className="maincontainer">
        <div className="container_2">
          <div className="create-new-ticket">
            <Button className="new-ticket-back"
              onClick={() => handleCustomBackButton ()}
              style={{
                backgroundColor: "#0A387D",
              }}
              variant="contained"
            >
              Back
            </Button>
            {/* <div className="ticket-new">
              <span>Create New Ticket</span>
            </div> */}
          </div>

          <div className="sub_container">
            {/* <form> */}
            <div className="title">
              <label className="label">Title <span className="mandatory">*</span></label>
              <div className="txt">
                <input
                  className="newticket-title-textbox"
                  type="text"
                  id="Title"
                  name="Title"
                  value={title}
                  maxLength={250}
                  disabled={isDisable}
                  onChange={inputTitle}
                />
                {errorTitle && (
                  <label style={{ color: "red" }}>{errorTitle}</label>
                )}
              </div>
            </div>

            <br />
            <div className="txt2">
              <label className="">Description  <span className="mandatory">*</span></label>
              <br />
              <div className="txt">
                <textarea
                  className="newticket-description"
                  type="text"
                  id="Description"
                  rows="3"
                  name="Description"
                  disabled={isDisable}
                  value={ticketDescription}
                  onChange={inputDesc}
                />
                {errorDesc && (
                  <label style={{ color: "red" }}>{errorDesc}</label>
                )}
              </div>
            </div>

            <br />

            <div className="user">
              <div className="select1">
                <label className="">Category  <span className="mandatory">*</span></label>

                <Select
                  className="sel"
                  sx={{marginBottom: '8px'}}
                  displayEmpty
                  name="category"
                  value={categoryId}
                  disabled={isDisable}
                  onChange={inputEvent}
                >
                  <MenuItem value="0" disabled>
                    Select
                  </MenuItem>
                  {categories.map((cat, id) => (
                    <MenuItem key={id} value={cat.id}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </Select>
                {errorCat && <label style={{ color: "red" }}>{errorCat}</label>}
              </div>

              <div className="select2">
                <label className="">Sub Category</label>
                <Select
                  className="sel"
                  displayEmpty
                  name="category"
                  value={subCategoryId}
                  disabled={categoryId === 0 || isDisable}
                  onChange={inputEventSubCategory}
                >
                  <MenuItem value="0" disabled>
                    Select
                  </MenuItem>
                  {subCategories.map((cat, id) => (
                    <MenuItem key={id} value={cat.id}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              <div className="clientstyle">
            <label className="client">
                Client <span className="mandatory">*</span>
            </label>
            <Autocomplete
                id="search-dropdown"
                className="sel2 newticket-autocomplete-project-client-style"
                disabled={isDisable || loading} // Disable if loading or explicitly disabled
                options={clients} // Use the clients fetched from API
                getOptionLabel={(option) => option.name || ''} // Display name in dropdown
                onChange={(event, value) => onChangeClient(event, value)} // Handle dropdown selection
                onInputChange={(event, value) => onInputChangeClient(event, value)} // Handle input changes
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={loading ? 'Loading...' : 'Search'}
                        variant="outlined"
                    />
                )}
                filterOptions={(options) => options} // Don't filter; let the backend handle it
                isOptionEqualToValue={(option, value) => option.name === value.name} // Avoid duplicate errors
            />
            {errorClient && (
                <label style={{ color: 'red' }}>{errorClient}</label> // Display error message
            )}
        </div>
              
            </div>
            <br />

            <div className="userstyle3">
            <div className="ptaglab">
                <label className="ptag">Project Tag <span className="mandatory">*</span></label>
                <Autocomplete
                    id="search-dropdown"
                    className="sel2 newticket-autocomplete-project-client-style"
                    disabled={isDisable || loading}
                    options={projects}
                    getOptionLabel={(option) => option.name || ''}
                    onChange={(event, value) => onChangeProject(event, value)}
                    duplicate={false}
                    onInputChange={(event, value) => {
                      if (event) {
                          onInputChangeProject(event, value);
                      }
                  }} // Handle input changes
                  renderInput={(params) => (
                      <TextField
                          {...params}
                          placeholder={loading ? 'Loading...' : 'Search'}
                          variant="outlined"
                      />
                  )}
                  filterOptions={(options) => options} 
                  isOptionEqualToValue={(option, value) => option.name === value.name} // Avoid duplicate errors
              />
              {errorProject && (
                  <label style={{ color: 'red' }}>{errorProject}</label> // Display error message
              )}
              </div>
             

              <div className="userstyle4">
                <label className="lab1">Status</label>

                <Select
                  className="status"
                  value={statusId}
                  displayEmpty
                  disabled={isDisable}
                  name="projectTag"
                  onChange={inputEvent4}
                >
                  <MenuItem value="21" defaultValue="New">
                    New
                  </MenuItem>
                  {/* {
                      status.map((stat, idś) => (
                        <MenuItem key={id} value={stat.id}>{stat.name}</MenuItem>
                      ))
                    } */}
                </Select>
              </div>

              <div className="styleduedate">
                <label className="labdate">Due Date <span className="mandatory">*</span></label>

                <DatePicker
                  className="date"
                  selected={dueDate}
                  disabled={isDisable}
                  dateFormat="MM-dd-yyyy"
                  onChange={(date) => handleChangeDate(date)}
                  minDate={new Date()}
                />
                  {errorDate && (
                  <label style={{ color: "red" }}>{errorDate}</label>
                )}
              </div>
            </div>

            <br />
            <div className="styleprior">
                <FormControl component="fieldset" sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  <FormLabel className="lab">Priority</FormLabel>
                  <RadioGroup
                    sx={{
                      flexWrap: 'nowrap',
                      marginLeft: 5
                    }}
                    row
                    aria-label="priority"
                    name="row-radio-buttons-group"
                    value={priorityId}
                    onChange={(e) => {
                      setPriorityId(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      disabled={isDisable}
                      value="1"
                      control={
                        <Radio
                          sx={{
                            color: "#b2a429",
                            "&.Mui-checked": { color: "#ffeb3b" },
                            
                          }}
                        />
                      }
                      label="Low"
                    />
                    <FormControlLabel
                      disabled={isDisable}
                      value="3"
                      control={
                        <Radio
                          sx={{
                            color: "#357a38",
                            "&.Mui-checked": { color: "#357a38" },
                          }}
                        />
                      }
                      label="Medium"
                    />
                    <FormControlLabel
                      disabled={isDisable}
                      value="2"
                      control={
                        <Radio
                          sx={{
                            color: "#aa2e25",
                            "&.Mui-checked": { color: "#aa2e25" },
                          }}
                        />
                      }
                      label="High"
                    />
                  </RadioGroup>
                </FormControl>
              </div>

            <br />

            <div className="user2">
              <div className="lab2">
                <label>Assign To  <span className="mandatory">*</span></label>
              </div>

              <Autocomplete
                id="free-solo-demo"
                className="newticket-autocomplete-style"
                freeSolo
                multiple
                onChange={(event, value, reason, detail) => onChangeAssignValues(event, value, reason, detail)}
                duplicate={false}
                onInputChange={(e, v) => onInputChange(e, v)}
                options={assignOptions}
                getOptionLabel={(option) => option.display}
                renderInput={(params) => <TextField {...params} placeholder='Search' />}
                renderTags={(values, getTagProps) => {
                  const seen = new Set();
                  const filteredArr = values.filter(el => {
                    const duplicate = seen.has(el.id);
                    seen.add(el.id);
                    return !duplicate;
                  });
                  return (
                    filteredArr.map((option, index) => (
                      <Chip label={option.display} {...getTagProps({ index })}></Chip>
                    ))
                  )
                }}
              />
              {errorAssign && (
                <label style={{ color: "red" }}>{errorAssign}</label>
              )}
            </div>
            <div className="dragdrop">
              <Stack direction="row" alignItems="center" spacing={2}>
                <label htmlFor="contained-button-file">
                  <Input
                    id="contained-button-file"
                    disabled={isDisable}
                    onChange={onFileChange}
                    multiple
                    type="file"
                  />

                  <Button
                    className="add2"
                    disabled={isDisable}
                    variant="contained"
                    component="span"
                  >
                    Upload or Drag/Drop Files Here. Total combined size must be below 5 MB
                  </Button>
                </label>

                <label htmlFor="icon-button-file">
                  <Input accept="image/*" id="icon-button-file" type="file" />
                </label>
              </Stack>
              <Typography component="span" sx={{ color: 'red' }}> Supported File Types:  Only .jpg / .jpeg / .png / .zip / .txt / .doc / .docx / .xlsx / .xls / .pdf  </Typography>
            </div>

            {errfileformat && (
              <label style={{ color: "red" }}>{errfileformat}</label>
            )}

            {errfileSize && (
              <label style={{ color: "red" }}>{errfileSize}</label>
            )}

            {showName.length > 0
              ? showName.map((shw, id) => (
                <div className="showFile" key={id}>
                  {shw}
                  <DeleteOutlineIcon
                    className="delFile"
                    delattach={shw}
                    onClick={remFile}
                  />
                </div>
              ))
              : " "}

            {/* </form> */}

            <div className="buttonstyle">
              <button className="button1" type="submit" onClick={formSubmit}>
                {loading ? "Loading..." : "Save"}
              </button>
              <button className="button3" onClick={cancelButton}>
                Cancel
              </button>
            </div>
          </div>
        </div>

        <div className="accordian">
          <p>Suggestions/FAQs</p>
          {questions.length < 1 ? (
            <LinearProgress />
          ) : (
            questions.map((quest, id) => (
              <div className="accordianstyle" key={id}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography className="suggestion question">
                      {quest.question}
                    </Typography>
                  </AccordionSummary>
                  {quest.answers.map((ans, id) => (
                    <AccordionDetails key={id}>
                      <Typography className="suggestion">{ans.answers}</Typography>
                    </AccordionDetails>
                  ))}
                </Accordion>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default Newticket;
